<form [formGroup]="form" (ngSubmit)="submit()">
    <h1 DraggableDialog mat-dialog-title>Skapa användare</h1>
    <mat-dialog-content>
      <div class="input-row-group">
        <mat-form-field floatLabel="always">
          <mat-label>Förnamn</mat-label>
          <input type="text" matInput placeholder="Förnamn" formControlName="givenName" (focusout)="focusOutName()">
        </mat-form-field>

        <mat-form-field floatLabel="always">
          <mat-label>Efternamn</mat-label>
          <input type="text" matInput placeholder="Efternamn" formControlName="surName" (focusout)="focusOutName()">
        </mat-form-field>
      </div>
      <div class="input-row-group">
        <mat-form-field floatLabel="always">
          <mat-label>ChaufförsKod (4tkn)</mat-label>
          <input type="text" matInput placeholder="ChaufförsKod (4tkn)" formControlName="employmentNumber" (focusout)="focusOutNumber()">
          <mat-error *ngIf="employmentNumberExists">Anställningsnummer används redan</mat-error>
        </mat-form-field>


        <mat-checkbox formControlName="active">Aktiv</mat-checkbox>
      </div>

      <div class="input-group">
        <mat-form-field floatLabel="always">
          <mat-label>Visningsnamn</mat-label>
          <input type="text" matInput placeholder="Visningsnamn" formControlName="name">
        </mat-form-field>

        <mat-form-field floatLabel="always">
          <mat-label>InloggningsId</mat-label>
          <input type="text" matInput placeholder="InloggningsId" formControlName="loginId">
        </mat-form-field>


      </div>


      <div class="input-row-group">
        <mat-form-field floatLabel="always">
          <mat-label>Flygplatser</mat-label>
          <mat-select placeholder="Airports" [formControl]="airports" multiple>
            <mat-select-trigger>
              {{airports.value ? airports.value[0] : ''}}
              <span *ngIf="airports.value?.length > 1" class="additional-selection">
                (+{{airports.value.length - 1}} others)
              </span>
            </mat-select-trigger>
            <mat-option *ngFor="let airport of airportsValues" [value]="airport">{{airport}}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field floatLabel="always">
          <mat-label>Aktuell flygplats</mat-label>
          <mat-select formControlName="currentAirportID">
            <mat-option value="ARN">ARN</mat-option>
          </mat-select>
          <mat-error *ngIf="form.controls.currentAirportID.hasError('required')">Flygplats måste väljas</mat-error>
        </mat-form-field>
      </div>

      <div class="input-group">
        <mat-form-field floatLabel="always">
          <mat-label>Kompetenser</mat-label>
          <mat-select placeholder="Kompetenser" [formControl]="skills" multiple>
            <mat-select-trigger>
              {{skills.value ? skills.value[0] : ''}}
              <span *ngIf="skills.value?.length > 1" class="additional-selection">
                (+{{skills.value.length - 1}} others)
              </span>
            </mat-select-trigger>
            <mat-option *ngFor="let skill of skillsValues" [value]="skill">{{skill}}</mat-option>
          </mat-select>
        </mat-form-field>

        <!-- Only show if admin -->
        <mat-form-field floatLabel="always" *ngIf="isAdmin">
          <mat-select placeholder="Rättigheter" [formControl]="permissions" multiple>
            <mat-select-trigger>
              {{permissions.value ? permissions.value[0] : ''}}
              <span *ngIf="permissions.value?.length > 1" class="additional-selection">
                (+{{permissions.value.length - 1}} others)
              </span>
            </mat-select-trigger>
            <mat-option *ngFor="let permission of permissionValues" [value]="permission">{{permission}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

    </mat-dialog-content>
    <hr />
    <mat-dialog-actions>
      <button mat-raised-button type="submit" color="primary" [disabled]="!form.valid">Skapa</button>
      <button mat-raised-button type="button" color="primary" mat-dialog-close>Avbryt</button>
    </mat-dialog-actions>
  
</form>
